import React from "react";
import { Container, Row, Col, Card, CardHeader, CardBody } from "shards-react";

import PageTitle from "../../components/common/PageTitle";
import DashboardIndex from "../../components/dashboard";
import RequestsIndex from "../../components/Requests";
import GroundCards from "../../components/Requests/GroundCards";
import PriceAgrees from "../../components/Requests/PriceAgrees";
import RequestsArchive from "../../components/Requests/RequestArchive";


const PriceAgreesView = () => (
  <Container fluid className="main-content-container px-4 backend">

    <Row noGutters className="page-header py-4">
      <PageTitle sm="4" title="Prijsafspraken" subtitle="Dirix Elsloo B.V." className="text-sm-left" />
    </Row>


    <Row>
      <Col lg="12">
          <PriceAgrees />
       
      </Col>
    </Row>
  </Container>
);

export default PriceAgreesView;
